import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50c46304"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row flex-between justify-content-between calendar-view-header" }
const _hoisted_2 = { class: "col-md-3" }
const _hoisted_3 = { class: "fullscreen-modal__top-title" }
const _hoisted_4 = { class: "fullscreen-modal__title" }
const _hoisted_5 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_6 = { class: "position-relative" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = {
  key: 0,
  class: "calendar-selection__alert"
}
const _hoisted_11 = {
  key: 0,
  class: "calendar-selection__warning"
}
const _hoisted_12 = {
  key: 1,
  class: "col-md-4"
}
const _hoisted_13 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_14 = {
  key: 0,
  class: "calendar-selection__default"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-warning" }, null, -1))
const _hoisted_16 = { class: "position-relative" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-6" }
const _hoisted_19 = { class: "col-6" }
const _hoisted_20 = {
  key: 0,
  class: "calendar-selection__alert"
}
const _hoisted_21 = {
  key: 0,
  class: "calendar-selection__warning"
}
const _hoisted_22 = {
  key: 1,
  class: "my-4"
}
const _hoisted_23 = { class: "row mt-5 mt-md-0" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "col-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarSelection = _resolveComponent("CalendarSelection")!
  const _component_PriceTendency = _resolveComponent("PriceTendency")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_PriceTendencyLegend = _resolveComponent("PriceTendencyLegend")!
  const _component_SeasonsLegend = _resolveComponent("SeasonsLegend")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.translate('shop.configuration.choose-date')), 1),
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.title), 1)
      ]),
      (!_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_CalendarSelection, {
                    label: "am",
                    ISODate: _ctx.selectedDateStart
                  }, null, 8, ["ISODate"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_CalendarSelection, {
                    label: "bis",
                    ISODate: _ctx.selectedDateEnd
                  }, null, 8, ["ISODate"])
                ])
              ]),
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (_ctx.noAvailableDates)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.translate('shop.configuration.no-available-dates')), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (_ctx.presalesExpiredMessage && _ctx.selectedDateStart)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.presalesExpiredMessage), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_PriceTendency, {
              selectedDateStart: _ctx.selectedDateStart,
              selectedDateEnd: _ctx.selectedDateEnd,
              ticketId: _ctx.ticketId,
              onNoAvailableDates: _ctx.changeNoAvailableDates,
              onOnHideServiceView: _ctx.onHideServiceView,
              onOnHidePriceTendency: _ctx.onHidePriceTendency,
              onIsLoadingPrice: _ctx.onChangeLoadingPrice,
              onPresalesExpiredMessage: _ctx.changePresalesExpiredMessage
            }, null, 8, ["selectedDateStart", "selectedDateEnd", "ticketId", "onNoAvailableDates", "onOnHideServiceView", "onOnHidePriceTendency", "onIsLoadingPrice", "onPresalesExpiredMessage"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          (!_ctx.selectedDateStart)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _hoisted_15,
                _createTextVNode(" " + _toDisplayString(_ctx.translate('shop.configuration.choose-date-in-calendar')), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_CalendarSelection, {
                  label: "am",
                  ISODate: _ctx.selectedDateStart
                }, null, 8, ["ISODate"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_CalendarSelection, {
                  label: "bis",
                  ISODate: _ctx.selectedDateEnd
                }, null, 8, ["ISODate"])
              ]),
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (_ctx.noAvailableDates)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.translate('shop.configuration.no-available-dates')), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (_ctx.presalesExpiredMessage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.presalesExpiredMessage), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createVNode(_component_PriceTendency, {
            selectedDateStart: _ctx.selectedDateStart,
            selectedDateEnd: _ctx.selectedDateEnd,
            ticketId: _ctx.ticketId,
            onOnHideServiceView: _ctx.onHideServiceView,
            onNoAvailableDates: _ctx.changeNoAvailableDates,
            onOnHidePriceTendency: _ctx.onHidePriceTendency,
            onIsLoadingPrice: _ctx.onChangeLoadingPrice,
            onPresalesExpiredMessage: _ctx.changePresalesExpiredMessage
          }, null, 8, ["selectedDateStart", "selectedDateEnd", "ticketId", "onOnHideServiceView", "onNoAvailableDates", "onOnHidePriceTendency", "onIsLoadingPrice", "onPresalesExpiredMessage"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Calendar, {
      errorMode: _ctx.noAvailableDates,
      onMinSelectableDates: _ctx.changeMinSelectableDates,
      onChangeDateStart: _ctx.onChangeDateStart,
      onChangeDateEnd: _ctx.onChangeDateEnd,
      selectedDateStart: _ctx.selectedDateStart,
      selectedDateEnd: _ctx.selectedDateEnd,
      ticketId: _ctx.ticketId
    }, null, 8, ["errorMode", "onMinSelectableDates", "onChangeDateStart", "onChangeDateEnd", "selectedDateStart", "selectedDateEnd", "ticketId"]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        (!_ctx.hidePriceTendencyLegend)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createVNode(_component_PriceTendencyLegend)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(_component_SeasonsLegend)
      ])
    ])
  ], 64))
}